module.exports = __webpack_public_path__ + "img/ANZ.1acb46fe.png";